import { useBetween } from "use-between";

import "./index.scss";
import useShopify from "../../../useShopify";
import { useEffect, useState } from "react";
// import ColorToggle from '../../../components/colortoggle';
import { Container, Button, Carousel, Form, Modal } from "react-bootstrap";
import Back from "../../../components/back";
import WizButton from "../../../components/wiz/wiz-button";

const Details = ({ prev, next, selectionState, updateSelectionState }) => {
  const { product } = useBetween(useShopify);
  const [isInfo, setIsInfo] = useState(false);
  const [desc, setDesc] = useState("");
  const [includes, setIncludes] = useState("");
  const [details, setDetails] = useState("");
  // const [color, setColor] = useState(false);
  // const [colorName, setColorName] = useState('matte black');
  const [showRequiredField, setShowRequiredField] = useState(false);
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [selectedProductDescription, setSelectedProductDescription] = useState("");
  const [selectedProductTitle, setSelectedProductTitle] = useState("");

  const { campaign, setImage, setNote, note } = useBetween(useShopify);
  const changeHandler = (event) => {
    setImage(event.target.files[0]);
  };

  const { sizeOptions, selectedSizes, selections, skuOptions, genderOptions } = selectionState;

  const isRegent =
    campaign.companyId === process.env.REACT_APP_REGENT_COMPANY_ID;
  const isLiveNation = campaign.companyId === "65d52364dc2cf135135301fd";
  const isWiz = campaign.companyId === "67981cfbdca127a271575000";
  const isCyeraSecretSanta2 = campaign.name === "CYERA SECRET SANTA GIFTS";
  const isPlenty = campaign.companyId === "696aaa2dcee86b5fec96369d";

  useEffect(() => {
    if (product) {
      const detailsArr = product.descriptionHtml.split("<!-- split -->");
      setDesc(detailsArr[1]);
      setIncludes(detailsArr[2]);
      setDetails(detailsArr[3]);
    }
  }, [product]);

  const handleSizeChange = (index, size) => {
    updateSelectionState({
      selectedSizes: { ...selectedSizes, [index]: size },
    });
  };

  const allItemsSelected = isRegent
    ? selections.every(
        (gender, genderIndex) =>
          gender.length === skuOptions[genderIndex].length &&
          gender.every((option) => option !== null)
      )
    : !!product;

  const allSizesSelected = isRegent
    ? Object.keys(selectedSizes).length === selections.flat().length &&
      Object.values(selectedSizes).every((size) => size !== "")
    : true;

  const canProceed = allItemsSelected;
  const canCheckout = isRegent
    ? allItemsSelected && allSizesSelected
    : allItemsSelected;

  const handleCheckout = () => {
    if (!canCheckout) {
      if (!allItemsSelected) {
        alert("Please select all items before proceeding to checkout.");
      } else if (isRegent && !allSizesSelected) {
        alert("Please select all sizes before proceeding to checkout.");
      }
    } else {
      if ((note === "" || note === " ") && isLiveNation) {
        setShowRequiredField(true);
      } else {
        setShowRequiredField(false);
        next();
      }
    }
  };

  const handleShowDescription = (product) => {
    setSelectedProductDescription(product.descriptionHtml);
    setSelectedProductTitle(product.title);
    setShowDescriptionModal(true);
  };

  return (
    <div className={`details-container ${isPlenty ? "plenty-details" : ""}`}>
      {!isPlenty && (isInfo ? <Back back={() => setIsInfo(false)} /> : <Back back={prev} />)}
      <div className="product-img">
        {isRegent ? (
          <Carousel
            className={`${isRegent ? "regent-carousel" : ""}`}
            controls={false}
          >
            {selections.flat().map((product, index) =>
              product && product.images && product.images.length > 0 ? (
                <Carousel.Item key={index}>
                  <img
                    src={product.images[0].src}
                    alt={`Product ${index + 1}`}
                    style={isCyeraSecretSanta2 ? { filter: 'blur(10px)' } : null}
                  />
                </Carousel.Item>
              ) : null
            )}
          </Carousel>
        ) : (
          product && (
            <Carousel controls={false}>
              {product.images.map((image, index) => (
                <Carousel.Item key={index}>
                  <img src={image.src} alt={`Product ${index + 1}`} style={isCyeraSecretSanta2 ? { filter: 'blur(10px)' } : null} />
                </Carousel.Item>
              ))}
            </Carousel>
          )
        )}
      </div>
      <Container>
        <div className="product-details">
          {!isInfo && !isRegent && !isWiz ? (
            <div style={ isWiz ? { color: "#0254EC" } : null }>
              {product && desc ? (
                <div
                  className="product-desc"
                  dangerouslySetInnerHTML={{ __html: desc }}
                />
              ) : (
                <div
                  className="product-desc"
                  dangerouslySetInnerHTML={{ __html: product.descriptionHtml }}
                />
              )}
              {sizeOptions && sizeOptions[0] && sizeOptions[0].length > 0 && (
                <Form.Group className="mb-3">
                  <Form.Label>Select Size:</Form.Label>
                  <Form.Control
                    as="select"
                    value={selectedSizes[0] || ""}
                    onChange={(e) => handleSizeChange(0, e.target.value)}
                  >
                    <option value="">Choose a size</option>
                    {sizeOptions[0].map((size, idx) => (
                      <option key={idx} value={size}>
                        {size}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              )}
              {isWiz ? (
                <WizButton
                  onClick={() => {
                    setIsInfo(true);
                  }}
                  // variant="secondary"
                  className="btn-cart mb-4 mt-4"
                >
                  Go To Cart
                </WizButton>
              ) : (
                <Button
                  variant="secondary"
                  className="btn-cart mb-4"
                  onClick={handleCheckout}
                  style={isPlenty ? {
                    backgroundColor: campaign.buttonColor || null,
                    color: campaign.buttonTextColor || null,
                    border: campaign.buttonStrokeColor ? `2px solid ${campaign.buttonStrokeColor}` : null,
                  } : null}
                >
                  {isPlenty ? "Claim Your Gift" : "go to cart"}
                </Button>
              )}
            </div>
          ) : (
            <>
              {isRegent ? (
                <>
                  {genderOptions.map((gender, genderIndex) => (
                    <div key={genderIndex}>
                      <h4>{gender}:</h4>
                      {selections[genderIndex].map((product, optionIndex) => {
                        const selectionIndex = genderIndex * 2 + optionIndex;
                        return product && (
                          <div key={optionIndex} className="product-info mb-3">
                            <div className="d-flex flex-column">
                              <p className="mb-1">{product.title}{selectedSizes[selectionIndex] ? ` - ${selectedSizes[selectionIndex]}` : ''}</p>
                              <Button
                                className="align-self-start"
                                onClick={() => handleShowDescription(product)}
                                style={{ 
                                  padding: '0 8px', 
                                  fontSize: '20px', 
                                  fontWeight: 'bold',
                                  backgroundColor: 'transparent',
                                  border: '1px solid #000',
                                  color: '#000',
                                  lineHeight: '1.2',
                                  marginBottom: '10px'
                                }}
                              >
                                +
                              </Button>
                            </div>
                            <Form.Group className="mb-3">
                              <Form.Label>
                                Select Size for {product.title}:
                              </Form.Label>
                              <Form.Control
                                as="select"
                                className={`size-dropdown-${selectionIndex}`}
                                value={selectedSizes[selectionIndex] || ""}
                                onChange={(e) =>
                                  handleSizeChange(selectionIndex, e.target.value)
                                }
                              >
                                <option value="">Choose a size</option>
                                {sizeOptions[selectionIndex].map((size, idx) => (
                                  <option key={idx} value={size}>
                                    {size}
                                  </option>
                                ))}
                              </Form.Control>
                            </Form.Group>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </>
              ) : (
                <div style={ isWiz ? { color: "#0254EC" } : null }>
                  {product && <h1>{product.title}</h1>}
                  <h4>Description</h4>
                  {product && desc ? (
                    <div
                      className="product-info"
                      dangerouslySetInnerHTML={{ __html: desc }}
                    />
                  ) : (
                    <div
                      className="product-info"
                      dangerouslySetInnerHTML={{ __html: product.descriptionHtml }}
                    />
                  )}

                  {sizeOptions &&
                    sizeOptions[0] &&
                    sizeOptions[0].length > 0 && (
                      <Form.Group className="mb-3">
                        <Form.Label>Select Size:</Form.Label>
                        <Form.Control
                          as="select"
                          value={selectedSizes[0] || ""}
                          onChange={(e) => handleSizeChange(0, e.target.value)}
                        >
                          <option value="">Choose a size</option>
                          {sizeOptions[0].map((size, idx) => (
                            <option key={idx} value={size}>
                              {size}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    )}
                </div>
              )}

              {includes && (
                <div style={ isWiz ? { color: "#0254EC" } : null }>
                  <h4>Includes</h4>
                  <div
                    className="product-info"
                    dangerouslySetInnerHTML={{ __html: includes }}
                  />
                </div>
              )}
              {details && (
                <div style={ isWiz ? { color: "#0254EC" } : null }>
                  <h4>the details</h4>
                  <div
                    className="product-info"
                    dangerouslySetInnerHTML={{ __html: details }}
                  />
                </div>
              )}

              {campaign.enableImage && (
                <Form.Group className="mb-3 mt-4">
                  <Form.Label>UPLOAD YOUR IMAGE HERE:</Form.Label>
                  <Form.Control type="file" onChange={changeHandler} />
                </Form.Group>
              )}
              {campaign.enableNote && (
                <Form.Group>
                  <Form.Label style={{ marginBottom: "0px" }}>
                    ADD A CUSTOM NOTE:
                  </Form.Label>
                  {showRequiredField && (
                    <Form.Text className="text-sm">
                      <p
                        style={{
                          color: "rgba(255, 0, 0, 0.75)",
                          marginBottom: "2px",
                        }}
                      >
                        * required
                      </p>
                    </Form.Text>
                  )}
                  <Form.Control
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    as="textarea"
                    rows="4"
                    maxLength={255}
                  />
                  <Form.Label className="text-sm">255 Characters</Form.Label>
                </Form.Group>
              )}

              {isWiz ? (
                <WizButton
                  onClick={handleCheckout}
                  // variant="secondary"
                  className="btn-checkout mb-4 mt-4"
                  disabled={!canCheckout}
                >
                  Go To Checkout
                </WizButton>
              ) : (
                <Button
                  onClick={handleCheckout}
                  variant="secondary"
                  className="btn-checkout mb-4"
              >
                  {isRegent ? "review submission" : "go to checkout"}
                </Button>
              )}
            </>
          )}
        </div>
      </Container>

      {/* Description Modal */}
      <Modal
        show={showDescriptionModal}
        onHide={() => setShowDescriptionModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedProductTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="product-info"
            dangerouslySetInnerHTML={{
              __html: selectedProductDescription,
            }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Details;
